import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import moment from "moment";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/busytime/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/busytime/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";

  //Busy time Calender view parameter
  const start_date = values && values.start_date ? moment(values.start_date).format("YYYY-MM-DD HH:mm:ss") : "";
  const end_date = values && values.end_date ? moment(values.end_date).format("YYYY-MM-DD HH:mm:ss") : "";
  const timezone = values && values.timezone ? values.timezone : "";
  const type = values && values.type ? values.type : "";
  const staff_id = values && values.staff_id ? values.staff_id : "";
  const formName = values && values.formName ? values.formName : "";
  const formatSalonDatetime = (value) => {
    if (!value) return "";
    const parsed = moment(value, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss"], true);
    return (parsed.isValid() ? parsed : moment(value)).format("YYYY-MM-DD HH:mm:ss");
  };
  const showdate = values && values.showdate ? formatSalonDatetime(values.showdate) : "";
  const showstartdate = values && values.showstartdate ? formatSalonDatetime(values.showstartdate) : "";
  const showenddate = values && values.showenddate ? formatSalonDatetime(values.showenddate) : "";

  // console.log(moment().format("HH:mm:ss"));
  // console.log(start_date, end_date,  moment.tz.guess());
  //Busy time Calender view parameter close
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id || start_date) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination == false) {
      pagination = values.pagination;
    }
    if (values.pagination == true) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/busytime/view?page=${page}&${sortstring}` : `afterlogin/busytime/view?${sortstring}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
    client_id: values && values.client_id ? values.client_id : "",
    start_date: start_date,
    end_date: end_date,
    timezone: timezone,
    type: type,
    staff_id: staff_id,
    showdate: showdate,
    showstartdate: showstartdate,
    showenddate: showenddate,
    formName,
    page_name : values && values.page_name ? values.page_name : "" ,
    singlestaffaccess : values && values.singlestaffaccess ? values.singlestaffaccess : "" 
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/busytime/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const busytimeApiController = {
  create,
  update,
  view,
  deleted,
};
export default busytimeApiController;
